import { render, staticRenderFns } from "./itemUpdateModal.vue?vue&type=template&id=448dffca&scoped=true&"
import script from "./itemUpdateModal.vue?vue&type=script&lang=js&"
export * from "./itemUpdateModal.vue?vue&type=script&lang=js&"
import style0 from "./itemUpdateModal.vue?vue&type=style&index=0&id=448dffca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448dffca",
  null
  
)

export default component.exports